import { render, staticRenderFns } from "./send-email-sms.vue?vue&type=template&id=dad2195e&scoped=true&"
import script from "./send-email-sms.vue?vue&type=script&lang=js&"
export * from "./send-email-sms.vue?vue&type=script&lang=js&"
import style0 from "./send-email-sms.vue?vue&type=style&index=0&id=dad2195e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dad2195e",
  null
  
)

export default component.exports